<template>
	<div class="box">
		<LoadingSpinner />
	</div>
</template>

<script type="text/javascript">
	import Accounting from "@/mixins/Accounting.js"

	// Route de retour OAuth SUPER PDP : SUPER PDP renvoie le navigateur sur le redirect_uri (/superpdp) avec
	// code+state, que le routeur réinjecte dans cette route. On délègue l'échange du code à l'API puis on
	// ramène l'utilisateur sur l'onglet Super PDP (succès ou erreur explicite).
	export default {
		name: 'SuperPDPCallback',
		mixins: [Accounting],

		async created() {
			const query = this.$route.query
			const code = query.code
			const state = query.state
			const error = query.error
			const error_description = query.error_description
			if(!state || (!code && !error)) {
				this.$router.replace({ name: 'cards' })
				return
			}

			const retour = await this.exchangeSuperPDP({ state, code, error })
			if(retour && retour.accountingplan_id) {
				const target = { name: 'AccountingSuperPDP', params: { accountingplan_id: String(retour.accountingplan_id) } }
				if(retour.status === 'error') {
					target.query = { superpdp_error: error_description || error || '1' }
				}
				this.$router.replace(target)
			}
			else {
				this.$router.replace({ name: 'cards' })
			}
		},

		components: {
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}
</script>
